import localize from '@cvg/localization-util'
import logger from '@utils/logger'

import en from './en.json'
import es from './es.json'

// TODO add all text displayed in UI to each language json file
// If localization is not needed - you may delete the localizations folder

const locales = {
  en: {
    name: 'English',
    values: en
  },
  es: {
    name: 'Español',
    values: es
  }
}

const options = {
  logErrorCallback: message => logger.error(message, { locales })
}

export default localize(locales, options)
